document.addEventListener('DOMContentLoaded', function() {
    const observer = new IntersectionObserver(entries => {
        if (entries[0].intersectionRatio <= 0) {
            return
        }

        const el = entries[0].target
        observer.unobserve(el)

        fetch(el.dataset.url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((response) => response.text())
            .then((content) => {
                el.outerHTML = content
                bindLoadNextObserver()
            })
    })

    function bindLoadNextObserver() {
        const loadNextObserver = document.querySelector('[data-load-next]')
        if (loadNextObserver) {
            observer.observe(loadNextObserver)
        }
    }

    bindLoadNextObserver()
});
